import {
  useWSSnackbar,
  WSActions,
  WSElement,
  WSElementProps,
  WSForm,
  WSInputTextarea
} from "@wingspanhq/fe-component-library";
import * as Yup from "yup";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { useMutationUpdateWorkLog } from "../../../../query/workLog/mutations/useMutationUpdateWorkLog";

type FormData = {
  notes: string;
};

type Props = {
  workLogId: string;
  currentNotes?: string;
  onClose: (success: boolean) => void;
} & WSElementProps;

export const ModalEditWorkLogNotes: React.FC<Props> = ({
  workLogId,
  currentNotes,
  onClose,
  ...elementProps
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [updateWorkLog, updateWorkLogMeta] = useMutationUpdateWorkLog();

  return (
    <WSElement {...elementProps}>
      <WSForm<FormData>
        defaultValues={{ notes: currentNotes || "" }}
        validationSchema={Yup.object().shape({
          notes: Yup.string().max(2000, "Notes must be 2000 characters or less")
        })}
        onSubmit={async formData => {
          await updateWorkLog(
            { workLogId, request: { notes: formData.notes } },
            {
              onSuccess: () => {
                openSnackbar({
                  icon: { name: "check" },
                  message: "Notes updated"
                });
                onClose(true);
              },
              onError: () => {
                openSnackbar({
                  message: "Failed to update notes",
                  type: "error"
                });
              }
            }
          );
        }}
      >
        <WSForm.Field
          name="notes"
          label="Notes"
          component={WSInputTextarea}
          componentProps={{
            placeholder: "Add notes for this work log...",
            maxLength: 2000
          }}
        />

        <WSErrorMessage
          mt="M"
          contextKey="Other"
          error={updateWorkLogMeta.error}
        />

        <WSActions
          mt="XL"
          alignment="fill"
          buttons={[
            {
              kind: "Tertiary",
              label: "Cancel",
              type: "button",
              onClick: () => onClose(false)
            },
            {
              kind: "Primary",
              label: "Save",
              loading: updateWorkLogMeta.isLoading
            }
          ]}
        />
      </WSForm>
    </WSElement>
  );
};
